document.addEventListener("DOMContentLoaded", () => {
  // DOM element declarations (grouped at top)
  const container = document.getElementById("viewer-container");
  const toolbar = document.getElementById("toolbar");
  const toolbarButtons = Array.from(toolbar.querySelectorAll("i"));
  const menuButton = document.getElementById("btn-menu");
  const leftPanel = document.getElementById("controls-left-wrapper");

  // On mobile, open left panel on startup
  if (window.innerWidth <= 600) {
    leftPanel.classList.add("open");
  }

  // ...existing code...
  // =========================
  // DOM + constants
  // =========================
  // ...existing code...

  // ...existing code...
  // =========================
  // Debug flags
  // =========================
  const isAdmin = new URLSearchParams(window.location.search).has("admin");
  const DEBUG = new URLSearchParams(window.location.search).has("debug");

  // =========================
  // Helpers
  // =========================
  function getNodePath(obj) {
    const names = [];
    let cur = obj;
    while (cur) {
      if (cur.name) names.push(cur.name);
      cur = cur.parent;
    }
    return names.reverse().join(" > ");
  }

  function safeKeys(o) {
    try {
      return o ? Object.keys(o) : [];
    } catch {
      return [];
    }
  }

  function pickInterestingUserData(userData) {
    if (!userData) return null;
    const keys = Object.keys(userData);
    if (!keys.length) return null;

    const out = {};
    keys.forEach((k) => {
      const v = userData[k];
      if (v == null) return;

      if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") out[k] = v;
      else if (Array.isArray(v) && v.length <= 20) out[k] = v;
      else if (typeof v === "object") out[k] = Object.fromEntries(Object.entries(v).slice(0, 20));
    });

    return out;
  }

  function dumpCurrentModelToConsole(model, { maxMeshes = 200, deepSamples = 5 } = {}) {
    if (!model) {
      console.warn("dumpCurrentModelToConsole: no model provided");
      return;
    }

    const rows = [];
    let meshCount = 0;
    const deep = [];

    console.group("🧩 GLB Model Dump");

    model.traverse((m) => {
      if (!m.isMesh) return;

      meshCount++;
      if (meshCount > maxMeshes) return;

      const parentName = m.parent?.name || "";
      const path = getNodePath(m);

      const geomName = m.geometry?.name || "";
      const mat = m.material;
      const matName = Array.isArray(mat) ? mat.map((x) => x?.name || "").join(" | ") : mat?.name || "";
      const matType = Array.isArray(mat) ? mat.map((x) => x?.type || "").join(" | ") : mat?.type || "";

      const userDataKeys = safeKeys(m.userData);
      const parentUserDataKeys = safeKeys(m.parent?.userData);
      const geomUserDataKeys = safeKeys(m.geometry?.userData);
      const matUserDataKeys = Array.isArray(mat) ? [...new Set(mat.flatMap((x) => safeKeys(x?.userData)))] : safeKeys(mat?.userData);

      const extKeys = safeKeys(m.userData?.gltfExtensions);

      const box = new THREE.Box3().setFromObject(m);
      const size = box.getSize(new THREE.Vector3());

      rows.push({
        nodeName: m.name || "",
        parentName,
        path,
        geometryName: geomName,
        materialName: matName,
        materialType: matType,
        userDataKeys: userDataKeys.join(", "),
        parentUserDataKeys: parentUserDataKeys.join(", "),
        geometryUserDataKeys: geomUserDataKeys.join(", "),
        materialUserDataKeys: matUserDataKeys.join(", "),
        gltfExtensionKeys: extKeys.join(", "),
        bbox: `${size.x.toFixed(3)}, ${size.y.toFixed(3)}, ${size.z.toFixed(3)}`,
        uuid: m.uuid,
      });

      if (deep.length < deepSamples) {
        const parentChain = [];
        let cur = m;
        let hops = 0;
        while (cur && hops < 6) {
          parentChain.push({
            name: cur.name,
            type: cur.type,
            userData: pickInterestingUserData(cur.userData),
          });
          cur = cur.parent;
          hops++;
        }

        deep.push({
          mesh: m,
          meshName: m.name,
          parentName,
          path,
          meshUserData: pickInterestingUserData(m.userData),
          parentUserData: pickInterestingUserData(m.parent?.userData),
          geometryUserData: pickInterestingUserData(m.geometry?.userData),
          materialUserData: Array.isArray(mat) ? mat.map((x) => pickInterestingUserData(x?.userData)) : pickInterestingUserData(mat?.userData),
          parentChain,
        });
      }
    });

    console.log(`Meshes dumped: ${Math.min(meshCount, maxMeshes)} / total meshes encountered: ${meshCount}`);
    console.table(rows);

    console.group(`🔎 Deep samples (${deep.length})`);
    deep.forEach((d, i) => {
      console.group(`Sample ${i}: ${d.path || d.meshName || d.uuid}`);
      console.log("PATH:", d.path);
      console.log("Mesh userData:", d.meshUserData);
      console.log("Parent userData:", d.parentUserData);
      console.log("Geometry userData:", d.geometryUserData);
      console.log("Material userData:", d.materialUserData);
      console.log("Parent chain (name/type/userData):", d.parentChain);
      console.log("Raw mesh object:", d.mesh);
      console.groupEnd();
    });
    console.groupEnd();

    console.group("🌳 Top-level children (raw)");
    (model.children || []).forEach((c, i) => console.log(i, c.name, c.userData, c));
    console.groupEnd();
  }

  // Normalize uppercase JSON keys (CAMERA/TARGET/LIGHTING) to the lowercase shape your app uses
  function normalizeDetail(detail) {
    if (!detail) return detail;
    return {
      ...detail,
      camera: detail.camera ?? detail.CAMERA,
      target: detail.target ?? detail.TARGET,
      lighting: detail.lighting ?? detail.LIGHTING,
      showLayers: detail.showLayers ?? detail.SHOW_LAYERS,
      showMovie: detail.showMovie ?? detail.SHOW_MOVIE,
    };
  }

  // =========================
  // DOM + constants
  // =========================

  // Always hide toolbar by default
  toolbar.style.display = "none";
  // Hide all toolbar buttons by default
  toolbarButtons.forEach((btn) => (btn.style.display = "none"));

  // Show menu button only on mobile
  function updateMenuButtonVisibility() {
    if (window.innerWidth <= 600) {
      menuButton.style.display = "inline-block";
    } else {
      menuButton.style.display = "none";
      leftPanel.classList.remove("open");
    }
  }
  window.addEventListener("resize", updateMenuButtonVisibility);
  updateMenuButtonVisibility();

  // Toggle left panel on menu click
  menuButton.addEventListener("click", () => {
    leftPanel.classList.toggle("open");
  });

  const DEFAULT_LOAD_ZOOM = 1.5;
  const DEFAULT_ZOOM_ALL = 1.5;
  const DEFAULT_ZOOM_DIRECTION = new THREE.Vector3(1, 1, 1);
  const ZOOM_STEP = 0.1;

  // =========================
  // Three.js setup
  // =========================
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf0f0f0);

  const camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 0.1, 1000);
  camera.position.set(2, 2, 2);

  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(container.clientWidth, container.clientHeight);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.outputEncoding = THREE.sRGBEncoding;
  container.appendChild(renderer.domElement);

  const ambientLight = new THREE.AmbientLight();
  const directionalLight = new THREE.DirectionalLight();
  directionalLight.position.set(5, 5, 5);
  scene.add(ambientLight, directionalLight);

  const controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enablePan = true;
  controls.enableZoom = true;
  controls.enableRotate = true;

  const composer = new THREE.EffectComposer(renderer);
  composer.addPass(new THREE.RenderPass(scene, camera));
  const cc = new THREE.ShaderPass(THREE.ColorCorrectionShader);
  cc.renderToScreen = true;
  composer.addPass(cc);

  const loader = new THREE.GLTFLoader();
  let currentModel = null;

  // load guard to prevent race condition when changing details quickly
  let loadToken = 0;

  const DEFAULT_LIGHTING = {
    ambientIntensity: 0.6,
    ambientColor: "#ffffff",
    ambientOn: true,
    directionalIntensity: 0.8,
    directionalColor: "#ffffff",
    directionalOn: true,
    brightness: 1,
    contrast: 1,
  };

  const DEFAULT_CAMERA = {
    position: new THREE.Vector3(2, 2, 2),
    target: new THREE.Vector3(0, 0, 0),
    zoomMargin: 1.5,
    direction: new THREE.Vector3(1, 1, 1),
  };

  // =========================
  // Toast helper
  // =========================
  const toastEl = document.getElementById("toast");
  const toastBody = document.getElementById("toast-body");
  const uiToast = new bootstrap.Toast(toastEl);

  function showToast(message, type = "success") {
    toastBody.textContent = message;

    toastEl.classList.remove("bg-success", "bg-danger", "bg-warning");

    const normalized = type === "danger" ? "error" : type;
    toastEl.classList.add(normalized === "success" ? "bg-success" : normalized === "error" ? "bg-danger" : "bg-warning");

    uiToast.show();
  }

  // =========================
  // Model loading progress
  // =========================
  const modelProgressContainer = document.getElementById("model-progress-container");
  const modelProgressBar = document.getElementById("model-progress-bar");
  let lastProgressPct = -1;
  let progressIndeterminate = false;

  // Hide model progress loader on startup
  hideModelProgress();

  function showModelProgress() {
    if (!modelProgressContainer || !modelProgressBar) return;
    modelProgressContainer.style.display = "block";
    setProgressIndeterminate(true);
  }

  function hideModelProgress() {
    if (!modelProgressContainer || !modelProgressBar) return;
    modelProgressContainer.style.display = "none";
    modelProgressBar.style.width = "0%";
    modelProgressBar.setAttribute("aria-valuenow", "0");
    lastProgressPct = -1;
    progressIndeterminate = false;
  }

  function setModelProgress(pct) {
    if (!modelProgressBar) return;
    const clamped = Math.max(0, Math.min(100, pct));
    const rounded = Math.floor(clamped / 5) * 5;
    if (rounded === lastProgressPct) return;
    lastProgressPct = rounded;

    modelProgressBar.style.width = `${rounded}%`;
    modelProgressBar.setAttribute("aria-valuenow", String(rounded));
  }

  function setProgressIndeterminate(on) {
    if (!modelProgressBar) return;
    progressIndeterminate = !!on;

    if (progressIndeterminate) {
      modelProgressBar.style.width = "100%";
      modelProgressBar.setAttribute("aria-valuenow", "0");
      lastProgressPct = -1;
    } else {
      modelProgressBar.style.width = "0%";
      modelProgressBar.setAttribute("aria-valuenow", "0");
      lastProgressPct = -1;
    }
  }

  // =========================
  // Disposal helpers
  // =========================
  function disposeMaterial(mat) {
    for (const key in mat) {
      const value = mat[key];
      if (value && value.isTexture) value.dispose();
    }
    if (typeof mat.dispose === "function") mat.dispose();
  }

  function disposeModel(model) {
    if (!model) return;
    model.traverse((obj) => {
      if (!obj.isMesh) return;
      if (obj.geometry) obj.geometry.dispose();
      const mat = obj.material;
      if (Array.isArray(mat)) mat.forEach(disposeMaterial);
      else if (mat) disposeMaterial(mat);
    });
  }

  // =========================
  // Camera coords display
  // =========================
  function updateCameraCoords() {
    if (!isAdmin) return;
    const camPosEl = document.getElementById("camPos");
    const camTargetEl = document.getElementById("camTarget");
    if (!camPosEl || !camTargetEl) return;

    camPosEl.textContent = `x: ${camera.position.x.toFixed(2)}, y: ${camera.position.y.toFixed(2)}, z: ${camera.position.z.toFixed(2)}`;
    camTargetEl.textContent = `x: ${controls.target.x.toFixed(2)}, y: ${controls.target.y.toFixed(2)}, z: ${controls.target.z.toFixed(2)}`;
  }

  // =========================
  // Lighting (UPDATED: no rebinding inside applyLighting)
  // =========================
  let lightingUiBound = false;

  function bindLightingUIOnce() {
    if (!isAdmin || lightingUiBound) return;
    lightingUiBound = true;

    const ambientSlider = document.getElementById("ambientSlider");
    const ambientColor = document.getElementById("ambientColor");
    const ambientValue = document.getElementById("ambientValue");
    const ambientToggle = document.getElementById("ambientToggle");

    const directionalSlider = document.getElementById("directionalSlider");
    const directionalColor = document.getElementById("directionalColor");
    const directionalValue = document.getElementById("directionalValue");
    const directionalToggle = document.getElementById("directionalToggle");

    const brightnessSlider = document.getElementById("brightnessSlider");
    const brightnessValue = document.getElementById("brightnessValue");

    const contrastSlider = document.getElementById("contrastSlider");
    const contrastValue = document.getElementById("contrastValue");

    ambientToggle.addEventListener("change", () => {
      const enabled = ambientToggle.checked;
      ambientSlider.disabled = !enabled;
      ambientColor.disabled = !enabled;
      ambientLight.intensity = enabled ? parseFloat(ambientSlider.value) : 0;
      ambientValue.textContent = enabled ? ambientSlider.value : "0";
    });

    ambientSlider.addEventListener("input", () => {
      ambientLight.intensity = parseFloat(ambientSlider.value);
      ambientValue.textContent = ambientSlider.value;
    });

    ambientColor.addEventListener("input", () => ambientLight.color.set(ambientColor.value));

    directionalToggle.addEventListener("change", () => {
      const enabled = directionalToggle.checked;
      directionalSlider.disabled = !enabled;
      directionalColor.disabled = !enabled;
      directionalLight.visible = enabled;
      directionalLight.intensity = enabled ? parseFloat(directionalSlider.value) : 0;
      directionalValue.textContent = enabled ? directionalSlider.value : "0";
    });

    directionalSlider.addEventListener("input", () => {
      directionalLight.intensity = parseFloat(directionalSlider.value);
      directionalValue.textContent = directionalSlider.value;
    });

    directionalColor.addEventListener("input", () => directionalLight.color.set(directionalColor.value));

    brightnessSlider.addEventListener("input", () => {
      renderer.toneMappingExposure = parseFloat(brightnessSlider.value);
      brightnessValue.textContent = brightnessSlider.value;
    });

    contrastSlider.addEventListener("input", () => {
      const val = parseFloat(contrastSlider.value);
      cc.uniforms.powRGB.value.set(val, val, val);
      contrastValue.textContent = contrastSlider.value;
    });
  }

  function applyLighting(lighting) {
    const cfg = { ...DEFAULT_LIGHTING, ...(lighting || {}) };

    ambientLight.intensity = cfg.ambientOn ? cfg.ambientIntensity : 0;
    ambientLight.color.set(cfg.ambientColor);

    directionalLight.visible = !!cfg.directionalOn;
    directionalLight.intensity = cfg.directionalOn ? cfg.directionalIntensity : 0;
    directionalLight.color.set(cfg.directionalColor);

    renderer.toneMappingExposure = cfg.brightness;
    cc.uniforms.powRGB.value.set(cfg.contrast, cfg.contrast, cfg.contrast);

    if (!isAdmin) return;

    const ambientSlider = document.getElementById("ambientSlider");
    const ambientColor = document.getElementById("ambientColor");
    const ambientValue = document.getElementById("ambientValue");
    const ambientToggle = document.getElementById("ambientToggle");

    const directionalSlider = document.getElementById("directionalSlider");
    const directionalColor = document.getElementById("directionalColor");
    const directionalValue = document.getElementById("directionalValue");
    const directionalToggle = document.getElementById("directionalToggle");

    const brightnessSlider = document.getElementById("brightnessSlider");
    const brightnessValue = document.getElementById("brightnessValue");

    const contrastSlider = document.getElementById("contrastSlider");
    const contrastValue = document.getElementById("contrastValue");

    ambientToggle.checked = !!cfg.ambientOn;
    ambientSlider.value = cfg.ambientIntensity;
    ambientColor.value = cfg.ambientColor;
    ambientSlider.disabled = !cfg.ambientOn;
    ambientColor.disabled = !cfg.ambientOn;
    ambientValue.textContent = cfg.ambientOn ? String(cfg.ambientIntensity) : "0";

    directionalToggle.checked = !!cfg.directionalOn;
    directionalSlider.value = cfg.directionalIntensity;
    directionalColor.value = cfg.directionalColor;
    directionalSlider.disabled = !cfg.directionalOn;
    directionalColor.disabled = !cfg.directionalOn;
    directionalValue.textContent = cfg.directionalOn ? String(cfg.directionalIntensity) : "0";

    brightnessSlider.value = cfg.brightness;
    brightnessValue.textContent = String(cfg.brightness);

    contrastSlider.value = cfg.contrast;
    contrastValue.textContent = String(cfg.contrast);
  }

  // bind lighting UI once
  bindLightingUIOnce();

  // =========================
  // Description
  // =========================
  function applyDescription(detail) {
    const descriptionTextarea = document.getElementById("description");
    if (!descriptionTextarea) return;

    descriptionTextarea.value = detail.description || "";
    document.getElementById("detail-description").textContent = detail.description || "";
  }

  // =========================
  // Zoom-to-fit
  // =========================
  function zoomToFit(model, camera, controls, marginPercent = 1.0, directionOverride = null) {
    if (!model) return;

    const box = new THREE.Box3().setFromObject(model);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());

    const maxDim = Math.max(size.x, size.y, size.z);
    const fov = camera.fov * (Math.PI / 180);

    const direction = directionOverride ? directionOverride.clone().normalize() : new THREE.Vector3().subVectors(camera.position, controls.target).normalize();

    let distance = maxDim / (2 * Math.tan(fov / 2));
    distance *= marginPercent;

    camera.position.copy(center).add(direction.multiplyScalar(distance));

    camera.near = distance / 100;
    camera.far = distance * 100;
    camera.updateProjectionMatrix();

    controls.target.copy(center);
    controls.update();
  }

  // =========================
  // Toolbar buttons (UPDATED zoom direction)
  // Export image button
  document.getElementById("btn-export-image").onclick = () => {
    // Render the current view to the renderer's canvas
    composer.render();
    // Get the canvas element
    const canvas = renderer.domElement;
    // Always export as JPG
    const mimeType = "image/jpeg";
    const ext = "jpg";
    // Get data URL
    const dataURL = canvas.toDataURL(mimeType, 0.92);
    // Create a download link
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `detail-view-${Date.now()}.${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showToast("Image exported as JPG");
  };
  // =========================
  document.getElementById("btn-zoom-in").onclick = () => {
    const dir = new THREE.Vector3().subVectors(controls.target, camera.position).normalize();
    camera.position.add(dir.multiplyScalar(ZOOM_STEP));
    controls.update();
  };

  document.getElementById("btn-zoom-out").onclick = () => {
    const dir = new THREE.Vector3().subVectors(camera.position, controls.target).normalize();
    camera.position.add(dir.multiplyScalar(ZOOM_STEP));
    controls.update();
  };

  document.getElementById("btn-pan").onclick = () => {
    controls.enablePan = !controls.enablePan;
    showToast(controls.enablePan ? "Pan enabled (hold right mouse button to pan)" : "Pan disabled", controls.enablePan ? "success" : "error");
  };

  document.getElementById("btn-zoom-all").onclick = () => {
    zoomToFit(currentModel, camera, controls, DEFAULT_ZOOM_ALL, DEFAULT_ZOOM_DIRECTION);
  };

  // =========================
  // Load libraries (details, materials, defaults)
  // =========================
  let detailsData = [];

  function populateDetailsSelect(filterCategory = "all") {
    const sel = document.getElementById("detailsSelect");
    if (!sel) return;

    // reset dropdown
    sel.innerHTML = `<option value="">Select a detail</option>`;

    const filtered = detailsData.filter((d) => {
      const cat = d.category || "";
      if (filterCategory === "all") return true;
      return cat === filterCategory;
    });

    filtered.forEach((d) => {
      const o = document.createElement("option");
      o.value = d.id;
      o.textContent = d.name;

      // keep useful metadata
      o.dataset.category = (d.category || "").toLowerCase();
      o.dataset.json = `../api.cfm?method=getDetailJson&detailid=${encodeURIComponent(d.id)}`;

      sel.appendChild(o);
    });
  }

  fetch("../assets/json/details.json?t=" + Date.now())
    .then((r) => r.json())
    .then((data) => {
      detailsData = Array.isArray(data.details) ? data.details : [];

      // normalize CATEGORY -> category
      detailsData = detailsData.map((d) => ({
        ...d,
        category: (d.category ?? d.CATEGORY ?? d.Category ?? "").toLowerCase(),
      }));

      populateDetailsSelect("all");
    })
    .catch(() => {
      detailsData = [];
      populateDetailsSelect("all");
      showToast("Failed to load details.json", "danger");
    });

  let materialLibrary = {};

  fetch("../assets/json/materials.json?t=" + Date.now())
    .then((r) => r.json())
    .then((data) => {
      for (const key in data) {
        const mat = data[key];
        materialLibrary[key] = new THREE.MeshStandardMaterial({
          color: mat.color,
          roughness: mat.roughness,
          metalness: mat.metalness,
          transparent: mat.transparent || false,
          opacity: mat.opacity || 1,
        });
      }
    });

  fetch("../assets/json/defaults.json?t=" + Date.now())
    .then((r) => r.json())
    .then((data) => {
      window.defaultsData = data;
      showToast("Application defaults successfully loaded", "success");
    })
    .catch(() => {
      window.defaultsData = {};
      showToast("Failed to load defaults", "danger");
    });

  // =========================
  // Detail change handler (UPDATED: race guard + normalization)
  // =========================
  document.getElementById("detailsSelect").addEventListener("change", async (e) => {
    const token = ++loadToken;

    const opt = e.target.selectedOptions[0];
    // If no option or default is selected, clear description and return

    if (!opt || opt.value === "") {
      document.getElementById("description").value = "";
      document.getElementById("detail-description").textContent = "";
      // Hide toolbar if no detail selected
      toolbar.style.display = "none";
      // Hide all toolbar buttons
      toolbarButtons.forEach((btn) => (btn.style.display = "none"));
      return;
    }

    hideModelProgress();

    // stop movie if running (your existing variables below)
    movieRunning = false;
    if (movieTimeout) cancelAnimationFrame(movieTimeout);
    movieProgress = 0;
    movieFinished = false;
    progressBar.style.width = "0%";
    stopButton.style.display = "none";
    progressContainer.style.display = "none";

    // remove + dispose old model
    if (currentModel) {
      disposeModel(currentModel);
      scene.remove(currentModel);
      currentModel = null;
    }

    const jsonUrl = opt.dataset.json;

    // ensure defaults loaded
    if (!window.defaultsData) {
      try {
        const resp = await fetch("../assets/json/defaults.json?t=" + Date.now());
        window.defaultsData = await resp.json();
        showToast("Application defaults successfully loaded", "success");
      } catch {
        window.defaultsData = {};
        showToast("Failed to load defaults.json", "danger");
      }
    }

    // load detail JSON
    let detail;
    try {
      const resp = await fetch(jsonUrl);
      detail = await resp.json();
      detail = normalizeDetail(detail); // ✅ supports CAMERA/TARGET/LIGHTING
    } catch (err) {
      showToast("Failed to load detail JSON", "danger");
      return;
    }

    // merge
    const merged = {
      glb: detail.glb || window.defaultsData.glb,
      description: detail.description || window.defaultsData.description,
      lighting: { ...(window.defaultsData.lighting || {}), ...(detail.lighting || {}) },
      showLayers: detail.showLayers ?? window.defaultsData.showLayers ?? true,
      showMovie: detail.showMovie ?? window.defaultsData.showMovie ?? true,
      camera: {
        x: detail.camera?.x ?? window.defaultsData.camera?.position?.x ?? DEFAULT_CAMERA.position.x,
        y: detail.camera?.y ?? window.defaultsData.camera?.position?.y ?? DEFAULT_CAMERA.position.y,
        z: detail.camera?.z ?? window.defaultsData.camera?.position?.z ?? DEFAULT_CAMERA.position.z,
      },
      target: {
        x: detail.target?.x ?? window.defaultsData.camera?.target?.x ?? DEFAULT_CAMERA.target.x,
        y: detail.target?.y ?? window.defaultsData.camera?.target?.y ?? DEFAULT_CAMERA.target.y,
        z: detail.target?.z ?? window.defaultsData.camera?.target?.z ?? DEFAULT_CAMERA.target.z,
      },
    };

    showToast("Detail loaded and merged successfully", "success");

    // description
    document.getElementById("detail-description").textContent = merged.description;
    applyDescription(merged);

    // lighting
    applyLighting(merged.lighting);

    // load GLB
    const detailId = opt.value;
    const glbUrl = `../api.cfm?method=getDetailGlb&detailId=${encodeURIComponent(detailId)}&t=${Date.now()}`;

    showModelProgress();
    showToast("Loading model…", "success");

    loader.load(
      glbUrl,
      (gltf) => {
        if (token !== loadToken) return; // ✅ ignore stale loads
        hideModelProgress();

        currentModel = gltf.scene;
        scene.add(currentModel);

        // Hide left panel on mobile after GLB is loaded
        if (window.innerWidth <= 600) {
          leftPanel.classList.remove("open");
        }

        // ✅ heavy debug only when ?debug
        if (DEBUG) {
          dumpCurrentModelToConsole(currentModel);

          gltf.parser.getDependencies("node").then((nodes) => {
            console.group("📦 glTF nodes (Three objects)");
            console.log(nodes);
            console.groupEnd();
          });

          console.group("📦 glTF JSON (if available)");
          console.log(gltf.parser.json);
          console.groupEnd();
        }

        // build layer controls
        const layersDiv = document.getElementById("layer-controls");
        layersDiv.innerHTML = "";

        currentModel.traverse((m) => {
          if (!m.isMesh) return;

          m.userData.originalMaterial = m.material;

          const row = document.createElement("div");
          row.className = "layer-row";
          row.dataset.meshId = m.uuid;

          const cb = document.createElement("input");
          cb.type = "checkbox";
          cb.checked = true;
          cb.onchange = () => (m.visible = cb.checked);
          row.appendChild(cb);

          if (isAdmin) {
            const sel = document.createElement("select");

            const origOption = document.createElement("option");
            origOption.value = "original";
            origOption.textContent = "Original";
            sel.appendChild(origOption);

            for (const key in materialLibrary) {
              const o = document.createElement("option");
              o.value = key;
              o.textContent = key;
              sel.appendChild(o);
            }

            sel.onchange = (e) => {
              if (e.target.value === "original") {
                m.material = m.userData.originalMaterial;
              } else {
                const chosen = materialLibrary[e.target.value];
                if (chosen) m.material = chosen;
              }
            };
            row.appendChild(sel);
          }

          row.appendChild(document.createTextNode(m.name || "Unnamed"));
          layersDiv.appendChild(row);
        });

        // UI visibility
        // Show toolbar and all buttons only after GLB is loaded
        toolbar.style.display = "flex";
        toolbarButtons.forEach((btn) => (btn.style.display = "inline-block"));
        const layersPanel = document.getElementById("controls-layers");
        layersPanel.style.display = currentModel && merged.showLayers ? "block" : "none";

        const cameraButton = document.getElementById("btn-zoom-all");
        if (cameraButton) cameraButton.style.display = currentModel ? "inline-block" : "none";

        const playButton = document.getElementById("btn-movie");
        if (playButton) {
          if (!merged.showMovie) {
            playButton.style.display = "none";
            stopButton.style.display = "none";
            progressContainer.style.display = "none";
          } else {
            let meshCount = 0;
            currentModel.traverse((m) => {
              if (m.isMesh) meshCount++;
            });
            playButton.style.display = meshCount > 1 ? "inline-block" : "none";
          }
        }

        if (isAdmin) {
          const rightWrapper = document.getElementById("controls-right-wrapper");
          if (rightWrapper) rightWrapper.style.display = "flex";
        }

        // apply camera
        if (merged.camera && merged.target) {
          camera.position.set(merged.camera.x, merged.camera.y, merged.camera.z);
          controls.target.set(merged.target.x, merged.target.y, merged.target.z);
          controls.update();
        } else if (currentModel) {
          zoomToFit(currentModel, camera, controls, DEFAULT_LOAD_ZOOM, DEFAULT_ZOOM_DIRECTION);
        } else {
          camera.position.copy(DEFAULT_CAMERA.position);
          controls.target.copy(DEFAULT_CAMERA.target);
          controls.update();
        }

        showToast("Detail successfully loaded", "success");
      },
      (xhr) => {
        if (token !== loadToken) return;

        // If total exists, switch to determinate and show real progress
        if (xhr.total) {
          if (progressIndeterminate) setProgressIndeterminate(false);
          const pct = (xhr.loaded / xhr.total) * 100;
          setModelProgress(pct);
        }
        // else: stay indeterminate (already visible)
      },
    );
  });

  // =========================
  // Filter updated
  // =========================
  function resetViewerUI() {
    // Show left panel if no model is loaded, hide if model exists
    if (!currentModel) {
      leftPanel.classList.add("open");
    } else {
      leftPanel.classList.remove("open");
    }
    // stop movie safely (these vars exist later, but this function is called after they are defined)
    movieRunning = false;
    if (movieTimeout) cancelAnimationFrame(movieTimeout);
    movieProgress = 0;
    movieFinished = false;

    // hide movie UI
    if (progressBar) progressBar.style.width = "0%";
    if (stopButton) stopButton.style.display = "none";
    if (progressContainer) progressContainer.style.display = "none";

    // remove + dispose old model
    if (currentModel) {
      disposeModel(currentModel);
      scene.remove(currentModel);
      currentModel = null;
    }

    hideModelProgress();

    // hide panels/buttons
    // Do not hide/show toolbar or toolbar buttons here; category-filter should not affect them.
    const layersPanel = document.getElementById("controls-layers");
    if (layersPanel) layersPanel.style.display = "none";

    if (isAdmin) {
      const rightWrapper = document.getElementById("controls-right-wrapper");
      if (rightWrapper) rightWrapper.style.display = "none";
    }

    document.getElementById("detail-description").textContent = "";
  }

  (function bindCategoryFilter() {
    const radios = document.querySelectorAll('input[name="catFilter"]');
    if (!radios.length) return; // ✅ radios not present, do nothing

    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const selected = document.querySelector('input[name="catFilter"]:checked')?.value || "all";

        // reset dropdown selection
        const sel = document.getElementById("detailsSelect");
        if (sel) sel.value = "";

        // reset viewer
        resetViewerUI();

        // rebuild dropdown
        populateDetailsSelect(selected);
      });
    });
  })();

  // =========================
  // Movie settings (unchanged)
  // =========================
  let movieInterval = 3000;
  let movieTimeout = null;
  let movieRunning = false;
  let movieProgress = 0;
  let movieFinished = false;

  const stopButton = document.getElementById("btn-stop-movie");
  const progressContainer = document.getElementById("movie-progress-container");
  const progressBar = document.getElementById("movie-progress-bar");

  stopButton.style.display = "none";
  progressContainer.style.display = "none";

  function playLayerMovie(interval = 3000) {
    if (!currentModel) return;

    if (movieFinished) {
      movieProgress = 0;
      movieFinished = false;
    }

    movieRunning = true;
    movieInterval = interval;

    stopButton.style.display = "inline-block";
    progressContainer.style.display = "block";

    const layers = [];
    const controlsInRows = [];

    currentModel.traverse((m) => {
      if (!m.isMesh) return;

      layers.push(m);

      const row = document.querySelector(`#layer-controls .layer-row[data-mesh-id="${m.uuid}"]`);
      if (row) {
        const inputs = Array.from(row.querySelectorAll("input, select"));
        inputs.forEach((input) => (input.disabled = true));
        controlsInRows.push(inputs);
      } else {
        controlsInRows.push(null);
      }

      m.material.transparent = true;
    });

    const totalTime = layers.length * interval;
    let startTime = performance.now() - movieProgress * totalTime;

    function update(now) {
      if (!movieRunning) return;

      const elapsed = now - startTime;
      movieProgress = Math.min(elapsed / totalTime, 1);

      layers.forEach((m, i) => {
        const p = movieProgress * layers.length - i;
        m.material.opacity = Math.max(0, Math.min(1, p));

        const inputs = controlsInRows[i];
        if (inputs && inputs[0]) inputs[0].checked = m.material.opacity > 0;
      });

      progressBar.style.width = Math.round(movieProgress * 100) + "%";

      if (movieProgress < 1) {
        movieTimeout = requestAnimationFrame(update);
      } else {
        movieFinished = true;
        movieRunning = false;
        stopButton.style.display = "none";
        progressContainer.style.display = "none";
        controlsInRows.forEach((inputs) => inputs && inputs.forEach((input) => (input.disabled = false)));
      }
    }

    movieTimeout = requestAnimationFrame(update);
  }

  function stopLayerMovie() {
    movieRunning = false;
    if (movieTimeout) cancelAnimationFrame(movieTimeout);
    stopButton.style.display = "none";
    progressContainer.style.display = "none";
  }

  document.getElementById("btn-movie").addEventListener("click", () => {
    playLayerMovie(movieInterval);
  });

  stopButton.addEventListener("click", () => {
    stopLayerMovie();
  });

  // =========================
  // Save lighting settings
  // =========================
  document.getElementById("btn-save-lighting").addEventListener("click", async () => {
    const detailId = document.getElementById("detailsSelect").value;

    if (!detailId) {
      showToast("No detail selected", "error");
      return;
    }

    const lighting = {
      ambientOn: document.getElementById("ambientToggle").checked,
      ambientIntensity: parseFloat(document.getElementById("ambientSlider").value),
      ambientColor: document.getElementById("ambientColor").value,
      directionalOn: document.getElementById("directionalToggle").checked,
      directionalIntensity: parseFloat(document.getElementById("directionalSlider").value),
      directionalColor: document.getElementById("directionalColor").value,
      brightness: parseFloat(document.getElementById("brightnessSlider").value),
      contrast: parseFloat(document.getElementById("contrastSlider").value),
    };

    try {
      const res = await fetch("/api.cfm?method=saveLighting", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ detailId, lighting }),
      });

      if (!res.ok) throw new Error("Request failed");

      const result = await res.json();

      if (result.SUCCESS) showToast("Lighting settings saved", "success");
      else showToast(result.message || "Failed to save lighting", "error");
    } catch (err) {
      showToast("Error saving lighting settings", "error");
    }
  });

  // =========================
  // Save camera settings
  // =========================
  document.getElementById("btn-save-camera").addEventListener("click", async () => {
    const detailId = document.getElementById("detailsSelect").value;

    if (!detailId) {
      showToast("No detail selected", "error");
      return;
    }

    const payload = {
      detailId,
      camera: {
        x: camera.position.x,
        y: camera.position.y,
        z: camera.position.z,
      },
      target: {
        x: controls.target.x,
        y: controls.target.y,
        z: controls.target.z,
      },
    };

    try {
      const res = await fetch("/api.cfm?method=saveCamera", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Request failed");

      const result = await res.json();

      if (result.SUCCESS) showToast("Camera settings saved", "success");
      else showToast(result.message || "Failed to save camera", "error");
    } catch (err) {
      showToast("Error saving camera settings", "error");
    }
  });

  // =========================
  // Save description
  // =========================
  document.getElementById("btn-save-description").addEventListener("click", async () => {
    const detailId = document.getElementById("detailsSelect").value;
    if (!detailId) return showToast("No detail selected", "danger");

    const descriptionTextarea = document.getElementById("description");
    if (!descriptionTextarea) return showToast("Description field not found", "danger");

    const payload = { detailId, description: descriptionTextarea.value };

    try {
      const resp = await fetch("/api.cfm?method=saveDescription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

      showToast("Description saved successfully", "success");
    } catch (err) {
      showToast("Failed to save description", "danger");
    }
  });

  // =========================
  // Animation loop
  // =========================
  function animate() {
    requestAnimationFrame(animate);
    controls.update();
    composer.render();
    updateCameraCoords();
  }
  animate();

  // resize
  window.addEventListener("resize", () => {
    camera.aspect = container.clientWidth / container.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(container.clientWidth, container.clientHeight);
    composer.setSize(container.clientWidth, container.clientHeight);
  });

  // cleanup
  window.addEventListener("beforeunload", () => {
    try {
      hideModelProgress();

      if (currentModel) {
        disposeModel(currentModel);
        scene.remove(currentModel);
        currentModel = null;
      }

      controls?.dispose?.();
      renderer?.dispose?.();
      composer?.dispose?.();

      if (renderer?.domElement?.parentNode) {
        renderer.domElement.parentNode.removeChild(renderer.domElement);
      }
    } catch (e) {
      // swallow
    }
  });
  // Install popup logic (ensure DOM is ready)
  function isMobile() {
    return window.innerWidth <= 600 || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  const popup = document.getElementById("install-popup");
  const closeBtn = document.getElementById("install-close");
  if (isMobile() && popup && closeBtn) {
    popup.style.display = "block";
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
    });
  }
});
